import { render, staticRenderFns } from "./hwKanban.vue?vue&type=template&id=09470006&scoped=true&"
import script from "./hwKanban.vue?vue&type=script&lang=js&"
export * from "./hwKanban.vue?vue&type=script&lang=js&"
import style0 from "./hwKanban.vue?vue&type=style&index=0&id=09470006&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09470006",
  null
  
)

export default component.exports